import type { DraftRequest } from './types';

/** Flattens a draft into the text that would actually go over the wire, for token estimation. */
export function draftText(draft: DraftRequest): string {
  const parts: string[] = [draft.systemPrompt];
  for (const block of draft.contextBlocks) parts.push(block.content);
  if (draft.historySummary) parts.push(draft.historySummary);
  for (const turn of draft.history) parts.push(turn.content);
  parts.push(draft.userMessage);
  return parts.join('\n');
}
